<template>
  <section class="group-buttons">
    <sc-button
      :focused="filterAppSelected === 'allApps'"
      :active="filterAppSelected === 'allApps'"
      :text="allAppsButton"
      @click="handleSelectAllApps"
    />

    <sc-button
      :focused="filterAppSelected === 'installedApps'"
      :active="filterAppSelected === 'installedApps'"
      :text="allInstalledAppsButton"
      @click="handleSelectInstalledApps"
    />

    <sc-button
      :focused="filterAppSelected === 'appsNotInstalled'"
      :active="filterAppSelected === 'appsNotInstalled'"
      :text="allNotInstalledAppsButton"
      @click="handleSelectUninstalledApps"
    />
  </section>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import { ScButton } from "@intelipost-js/secure-components";

const { mapState, mapActions } = createNamespacedHelpers(
  "integrations/integrationsHome"
);

export default {
  components: {
    ScButton,
  },

  data() {
    return {
      filterAppSelected: "allApps",
      filteredApps: [],
    };
  },

  props: {
    availableAppList: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapState(["loading", "appList", "appsWithoutFilter"]),

    allAppsButton(){
      const size = this.availableAppList.length;
      return "Todos (" + size + ")"
    },

    allInstalledAppsButton(){
      const size = this.availableAppList.filter(
        (app) => app.status === 'INSTALLED' || app.status === 'MANUALLY_INSTALLED').length;
      return "Instalados (" + size + ")"
    },

    allNotInstalledAppsButton(){
      const size = this.availableAppList.filter(
        (app) => app.status === 'UNINSTALLED').length;
      return "Não instalados (" + size + ")"
    }

  },

  methods: {
    ...mapActions(["getAppList", "setFilteredAppList", "setAppsWithoutFilter"]),

    handleSelectAllApps() {
      this.filterAppSelected = "allApps";
      this.setFilteredAppList(this.appsWithoutFilter);
    },

    handleSelectInstalledApps() {
      this.filterAppSelected = "installedApps";

      const installedApps = this.appsWithoutFilter.filter(
        (app) => app.status === 'INSTALLED'
      );

      this.setFilteredAppList(installedApps);
    },

    handleSelectUninstalledApps() {
      this.filterAppSelected = "appsNotInstalled";

      const notInstalledApps = this.appsWithoutFilter.filter(
        (app) => app.status === 'UNINSTALLED'
      );

      this.setFilteredAppList(notInstalledApps);
    },
  },

  mounted() {
    this.setAppsWithoutFilter(this.availableAppList);
  },
};
</script>

<style>
.group-buttons {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/app-filter/installation-filter-button/InstallationFilterButton.vue?60e9f2d4